import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {Policy, Quote} from "@ferry/journey-services";
import {Footer} from "@ferry/portal-core";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {YourQuotesPanel} from "./YourQuotesPanel";
import {authorize, Overlay} from "@athena-portal/components";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IState {
    quotes?: Quote[];
    policies?: Policy[];
}

@authorize
export class QuotesPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your quote(s)");
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => this.setState({quotes}));
        this.customerPortalService.getPolicies().subscribe((policies: Policy[]) => {
            this.setState({policies});
        });
    }

    public render() {
        const {policies, quotes} = this.state;
        if (quotes && policies) {
            return (
                <React.Fragment>
                    <FalconHeader/>
                    <YourQuotesPanel
                        quotes={quotes}
                        isActivePoliciesPresent={policies.length > 0}
                        policies={policies}/>
                    <Footer/>
                </React.Fragment>
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}
